export const isEmpty = object => Object.keys(object).length === 0
